import React, {Component} from 'react';
import {Col, FormGroup, Input, Label, Row, UncontrolledTooltip} from "reactstrap";
import Select from"../../../local_node_modules/react-select"
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput, {conformToMask} from "react-text-mask";
import {validateComponent, validateField} from "../../../common/validation";
import Alert from "react-s-alert";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";

class CustomerWarningForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			error: {},
			warningType: null,
			isWarningTypeSelected: false,
			warningOption: null,
			isWarningOptionSelected: false,
			warningMail: null,
			warningPhone: null
		};

	}

	componentDidMount() {
		let selectedWarning = !!this.props.selectedWarning && this.props.selectedWarning;

		if (selectedWarning) {

			let warningType = selectedWarning.warningType.recordId;
			let isWarningTypeSelected = true;
			let warningOption = selectedWarning.warningOption.recordId;
			let isWarningOptionSelected = true;
			let warningMail = selectedWarning.warningMail;
			let warningPhone = selectedWarning.warningPhone;

			this.setState({
				warningType,
				isWarningTypeSelected,
				warningOption,
				isWarningOptionSelected,
				warningMail,
				warningPhone
			})
		}
	}

	componentWillUnmount() {
		this.setState({
			warningType: null,
			isWarningTypeSelected: false,
			warningOption: null,
			isWarningOptionSelected: false,
			warningMail: null,
			warningPhone: null,
		});
	}

	validateField(e) {
		let id = e.target.id;

		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangeWarningType(e) {
		this.setState({
			warningType: e.value,
			isWarningTypeSelected: true
		});

		if (this.props.mode === 'edit') {
			this.props.setNewWarningType(e.value);
		}
	}

	onChangeWarningOption(e) {
		this.setState({
			warningOption: e.value,
			isWarningOptionSelected: true
		});

		if (this.props.mode === 'edit') {
			this.props.setNewWarningOption(e.value);
		}
	}

	onChangeWarningMail(e) {
		this.setState({
			...this.state.warningMail,
			warningMail: e.target.value
		});

		if (this.props.mode === 'edit') {
			this.props.setNewWarningMail(e.target.value);
		}
	}

	onChangeWarningPhone(e) {

		console.log(e)

		this.setState({
			...this.state.warningPhone,
			warningPhone: e.target.value
		});

		if (this.props.mode === 'edit') {
			this.props.setNewWarningPhone(e.target.value);
		}
	}

	isConfirmButtonDisabled() {
		let warningPhone = this.state.warningPhone;
		let warningMail = this.state.warningMail;
		let warningOption = this.state.warningOption;

		if (warningOption === 1 && !!warningMail) {
			return false;
		} else if (warningOption === 2 && !!warningPhone) {
			return false;
		} else if (warningOption === 3 && (!!warningMail && !!warningPhone)) {
			return false;
		} else {
			return true;
		}
	}

	cancelNewWarning() {
		this.setState({
			warningType: null,
			isWarningTypeSelected: false,
			warningOption: null,
			isWarningOptionSelected: false,
			warningMail: null,
			warningPhone: null,
		});
		if (this.props.currentWarnings.length !== 0) {
			this.props.switchModeToList();
		}
	}

	defineWarningTypesDropdownList() {

		let warningTypes = this.props.warningTypes;
		let currentWarnings = this.props.currentWarnings && this.props.currentWarnings;

		let warningTypesDropdownList = [];

		if (!!warningTypes) {
			warningTypes.map(wt => {
				let warningType = {};
				warningType.label = wt.typeExplanation;
				warningType.value = wt.recordId;

				if (!!currentWarnings) {
					let found = false;
					currentWarnings.map(cw => {
						if (cw.warningType.recordId === wt.recordId) {
							found = true;
						}
					});
					!found && warningTypesDropdownList.push(warningType);
				} else {
					warningTypesDropdownList.push(warningType);
				}
			});

			if (this.props.mode === 'edit') {

				let selectedWarningType = this.props.selectedWarning.warningType;
				let warningType = {};

				warningType.label = selectedWarningType.typeExplanation;
				warningType.value = selectedWarningType.recordId;

				warningTypesDropdownList.push(warningType);
			}
		}

		return warningTypesDropdownList;
	}


	defineWarningOptionsDropdownList() {

		let warningOptions = this.props.warningOptions;

		let warningOptionsDropdownList = [];

		if (!!warningOptions) {
			warningOptions.map(wo => {
				let warningOption = {};

				warningOption.label = wo.optionExplanation;
				warningOption.value = wo.recordId;

				warningOptionsDropdownList.push(warningOption);
			})
		}

		return warningOptionsDropdownList;
	}

	async confirmNewWarning() {
		let currentWarnings = this.props.currentWarnings;
		let warningTypes = this.props.warningTypes;
		let warningOptions = this.props.warningOptions;

		if (this.validateComponent().valid) {

			let warningType = warningTypes.filter(wt => {
				return wt.recordId === this.state.warningType;
			})[0];

			let warningOption = warningOptions.filter(wo => {
				return wo.recordId === this.state.warningOption;
			})[0];

			let warningMail = (warningOption.recordId === 1 || warningOption.recordId === 3) ? this.state.warningMail : null;
			let warningPhone = (warningOption.recordId === 2 || warningOption.recordId === 3) ? this.state.warningPhone : null;

			let newWarning = {
				warningType: warningType,
				warningOption: warningOption,
				warningMail,
				warningPhone
			};


			let data = await this.props.saveOrUpdateCustomerWarning(newWarning);

			if (data) {

				newWarning.recordId = data.recordId;

				currentWarnings.push(newWarning);

				this.setState({
					warningType: null,
					isWarningTypeSelected: false,
					warningOption: null,
					isWarningOptionSelected: false,
					warningMail: null,
					warningPhone: null,
				});

				this.props.submitNewWarning(currentWarnings);
			}

		} else {
			Alert.error(this.arrangeErrorMessage(), {
				position: 'top-right',
				effect: 'stackslide',
				html: true,
				timeout: 5000
			});
		}
	}

	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.error);

		let errorArray = [];

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message) {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}

		this.setState({error: errorObject});

		return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/>').join('')
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tEmail':
				return 'e-Posta Adresi: ';
			case 'tPhone':
				return 'Telefon Numarası: ';
			default :
				return '';
		}
	}

	pickNewWarning() {
		let self = this;

		let validationResult = self.validateComponent();
		self.props.captureObject(validationResult);
	}

	render() {

		const isConfirmButtonDisabled = this.isConfirmButtonDisabled();

		const customerWarnings = this.props.currentWarnings;

		const warningTypes = this.defineWarningTypesDropdownList();
		const warningOptions = this.defineWarningOptionsDropdownList();

		return (
			<Col sm='12'>

				<button id='childObjectPicker' style={{display: 'none'}} onClick={() => this.pickNewWarning()}/>

				<Row>
					<Col sm="3" style={{padding: '0 0 0 5px'}}>
						{(this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
						<Col sm="12">
							<FormGroup>
								<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>Bildirim Türü</Label>
							</FormGroup>
						</Col>}
						{(this.props.mode === 'create' || this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
						<Col sm="12" className='tableLikeCell'>
							<Select
								clearable={false}
								className={!this.state.isWarningTypeSelected ? 'select-control warningFrame' : 'select-control'}
								value={this.state.warningType}
								onChange={(e) => this.onChangeWarningType(e)}
								placeholder="Seçiniz..."
								options={warningTypes}
							/>
						</Col>}
					</Col>

					{(!this.state.isWarningTypeSelected && (customerWarnings && customerWarnings.length === 0)) &&
					<div>
						<Label className="col-form-label" sm="12"></Label>
						<h4 className='blinker' style={{padding: '7% 0 0 0'}}>
							Hangi konuda bildirim almak istersiniz ?</h4>
					</div>}

					{this.state.warningType &&
					<Col sm="3" style={{padding: '0px'}}>
						{(this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
						<Col sm="12">
							<FormGroup>
								<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>Bildirim Şekli</Label>
							</FormGroup>
						</Col>}
						{(this.props.mode === 'create' || this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
						<Col sm="12" className='tableLikeCell'>
							<Select
								clearable={false}
								className={!this.state.isWarningOptionSelected ? 'select-control warningFrame' : 'select-control'}
								value={this.state.warningOption}
								onChange={(e) => this.onChangeWarningOption(e)}
								placeholder="Seçiniz..."
								options={warningOptions}
							/>
						</Col>}
					</Col>}

					{(this.state.isWarningTypeSelected && !this.state.isWarningOptionSelected && (customerWarnings && customerWarnings.length === 0)) &&
					<div>
						<Label className="col-form-label" sm="12"></Label>
						<h4 className='blinker' style={{padding: '7% 0 0 0'}}>
							Bildirimlerinizi size nasıl iletelim ?</h4>
					</div>}

					{this.state.warningOption &&
					<Col sm="3" style={{padding: '0px'}}>
						{(this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
						<Col sm="12">
							<FormGroup>
								<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>e-Posta</Label>
							</FormGroup>
						</Col>}
						{((this.props.mode === 'create' || this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
							(this.state.warningOption === 1 || this.state.warningOption === 3)) &&
						<Col sm="12" className={'tableLikeCell ' + 'form-group' + this.validateClass('tEmail')}>
							<MaskedInput className={this.state.warningMail ? 'form-control' : 'warningFrame form-control'}
										 type="text"
										 mask={emailMask}
										 name="email"
										 inputProps={{vdata: "email", vlength: '1,255'}}
										 id="tEmail"
										 onBlur={() => this.validateField({
											 target: {
												 id: "tEmail",
												 dataset: {vdata: "email", vlength: '1,255'},
												 value: this.state.warningMail
											 }
										 })}
										 placeholder="_________@______.___"
										 ref="tEmail"
										 value={this.state.warningMail}
										 onChange={(e) => this.onChangeWarningMail(e)}/>
							{this.validateMessage('tEmail') !== "" &&
							<UncontrolledTooltip placement="right" target="tEmail" delay={0}>
								{this.validateMessage("tEmail")}
							</UncontrolledTooltip>}
						</Col>}

						{((this.props.mode === 'create' || this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
							(this.state.warningOption === 2)) &&
						<Col sm="12" className='tableLikeCell'>
							<FormGroup>
								<Label className="col-form-label" sm="12">-</Label>
							</FormGroup>
						</Col>}
					</Col>}

					{this.state.warningOption &&
					<Col sm={this.props.mode === 'edit' ? '3' : '2'} style={{padding: '0px'}}>
						{(this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
						<Col sm="12">
							<FormGroup>
								<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>Telefon</Label>
							</FormGroup>
						</Col>}
						{((this.props.mode === 'create' || this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
							(this.state.warningOption === 2 || this.state.warningOption === 3)) &&
						<Col sm="12" className={'tableLikeCell ' + 'form-group' + this.validateClass('tPhone')}>
							<MaskedInput className={this.state.warningPhone ? 'form-control' : 'warningFrame form-control'}
										 type="text"
										 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
										 placeholder="+90__________"
										 name="phone"
										 inputProps={{vdata: "phone", vlength: '13,13'}}
										 id="tPhone"
										 onBlur={() => this.validateField({
											 target: {
												 id: "tPhone",
												 dataset: {vdata: "phone", vlength: '13,13'},
												 value: this.state.warningPhone
											 }
										 })}
										 guide={true}
										 ref='tPhone'
										 value={this.state.warningPhone}
										 onChange={(e) => this.onChangeWarningPhone(e)}/>
							{this.validateMessage('tPhone') !== "" &&
							<UncontrolledTooltip placement="right" target="tPhone" delay={0}>
								{this.validateMessage("tPhone")}
							</UncontrolledTooltip>}
						</Col>}

						{((this.props.mode === 'create' || this.props.mode === 'edit' || (customerWarnings && customerWarnings.length === 0)) &&
							(this.state.warningOption === 1)) &&
						<Col sm="12" className='tableLikeCell'>
							<FormGroup>
								<Label className="col-form-label" sm="12">-</Label>
							</FormGroup>
						</Col>}
					</Col>}

					{(this.props.mode === 'create') &&
					<Col sm="1" style={{padding: '0 5px 0 0'}}>
						{customerWarnings && customerWarnings.length === 0 &&
						<Col sm="12">
							<Label className="col-form-label"/>
						</Col>}
						<Row style={{padding: '0 22% 0 22%'}}>
							{!isConfirmButtonDisabled &&
							<Col sm='8' style={this.props.currentWarnings.length === 0 ? {padding: '15px 0 0 5%', textAlign: 'center'} :
								{padding: '5px 0 0 0', textAlign: 'center'}}>
								<button className='newWarningButton confirm blinker' onClick={() => this.confirmNewWarning()}/>
							</Col>}
							{!(customerWarnings.length === 0 && !this.state.warningType) &&
							<Col sm={isConfirmButtonDisabled ? '12' : '4'}
								 style={this.props.currentWarnings.length === 0 ? {padding: '15px 0 0 5%', textAlign: 'center'} :
									 {padding: '5px 0 0 0', textAlign: 'center'}}>
								<button className={isConfirmButtonDisabled ? 'newWarningButton' : 'newWarningButton cancel'}
										onClick={() => this.cancelNewWarning()}>
									{isConfirmButtonDisabled ? 'Vazgeç' : ''}
								</button>
							</Col>}
						</Row>
					</Col>}
				</Row>
			</Col>
		)
	}
}

export default CustomerWarningForm;